var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs-index _spread-out"},[(_vm.isNotApproved)?_c('ErrorNotApproved'):_c('SwiperTabs',{attrs:{"swiper_items":[
      {
        label: _vm.$t('jobs.nav.recruit_info'),
        url: _vm.localePath(_vm.URLs.show_recruit_info),
      },
      {
        label: _vm.$t('jobs.nav.seminars'),
        url: _vm.localePath(_vm.URLs.show_seminars),
      },
      {
        label: _vm.$t('jobs.nav.internships'),
        url: _vm.localePath(_vm.URLs.show_internships),
      } ],"header-options":_vm.headerOption,"touchMove":false}},[_c('SwiperTabItem',[_c('SearchJobs',{key:_vm.jobsListKey,attrs:{"is-active":true},on:{"paginationLinkClickHandler":function($event){_vm.jobsListKey=_vm.dayjs().format()}}})],1),_c('SwiperTabItem',[_c('SearchSeminars')],1),_c('SwiperTabItem',[_c('SearchInternships')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }